const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      '--diameter-thumb': (props) => `${props.thumbRadius}px`,
      '--rail-color': 'rgba(0, 0, 0, .2)',
      '--track-color': 'rgba(0, 0, 0, .7)',
      '--thumb-color': 'rgba(0, 0, 0, .9)',
      userSelect: 'none',
      marginTop: 28,
      height: 'var(--diameter-thumb)',
    },
    values: {
      position: 'absolute',
      zIndex: 1,
      top: -20,
      fontSize: 12,
    },
    rail: {
      position: 'absolute',
      zIndex: -2,
      left: 0,
      top: 'calc(50% - 1px)',
      height: 2,
      borderRadius: 2,
      width: '100%',
      background: 'var(--rail-color)',
    },
    track: {
      position: 'absolute',
      zIndex: -1,
      left: 0,
      top: 'calc(50% - 2px)',
      height: 4,
      borderRadius: 2,
      background: 'var(--track-color)',
      transform: 'translateX(calc(var(--diameter-thumb) * 0.5))',
    },
    thumb: {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      background: 'var(--thumb-color)',
      borderRadius: '50%',
      height: 'var(--diameter-thumb)',
      width: 'var(--diameter-thumb)',
      cursor: 'grab',
      '& $value': {
        background: theme.colors[3],
      },
    },
    active: {
      cursor: 'grabbing',
      zIndex: 10,
    },
    value: {
      position: 'absolute',
      zIndex: 1,
      left: '50%',
      transform: 'translateX(-50%)',
      top: -15,
      fontSize: 11,
      textAlign: 'center',
      width: 30,
      '--shadow': theme.colors[3],
      textShadow: '0px 1px 0px var(--shadow), 1px 0px 0px var(--shadow), 0px -1px 0px var(--shadow), 1px 1px 0px var(--shadow), -1px 1px 0px var(--shadow)',
    },
  }

  return output
}

export default style
